import { render, staticRenderFns } from "./ApplicantShowInternalHistory.vue?vue&type=template&id=79d4746f&"
import script from "./ApplicantShowInternalHistory.vue?vue&type=script&lang=js&"
export * from "./ApplicantShowInternalHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports